import {DATA} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {Builder} from '@wix/document-services-types'

interface SlotData {
    selector: string
    slotId: string
}
// TODO: remove once ContainerType is exported
type ContainerType = NonNullable<NonNullable<Builder.DataItem['container']>['containerType']>
export class SlotDataBuilder {
    private readonly slotSelector: string
    private readonly slotId: string

    constructor(slotData: SlotData) {
        this.slotSelector = slotData.selector
        this.slotId = slotData.slotId
    }

    toBuilderDataItem(): Builder.DataItem {
        return {
            dataType: DATA.DATA_TYPE.container,
            container: {
                containerType: 'slot' as ContainerType,
                selector: this.slotSelector,
                slot: {
                    slotId: this.slotId
                }
            }
        }
    }
}
